/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const ticketSchema = z.object({
  id: z.number(),
  category: z.string(),
  status: z.string(),
  title: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type ITicket = z.infer<typeof ticketSchema>;
